import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription, take } from 'rxjs';
import { Property } from '../../models/property';
import { PropertyService } from '../../services/PropertyService';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Result } from '../../models/result';

@Component({ standalone: false,
  selector: 'hot-edit-dialog',
  templateUrl: 'hot-edit-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['hot-edit-dialog.component.scss']
})
export class HotEditDialogComponent {
  public title: string= "CHANGE LIVE LISTING PARAMETER";
  public confirmButtonText = "Confirm";
  public cancelButtonText = "Cancel";

  public property!: Property;
  public minimumReservePrice!:number;
  public auctionUpdatedSubscription?:Subscription;
  public hotEditForm:FormGroup;

  public busy:boolean=false;
  
  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<HotEditDialogComponent>, private propertyService:PropertyService, public snackBar: MatSnackBar) {
    this.hotEditForm = new FormGroup({
      reservePrice: new FormControl<number|undefined>(undefined, Validators.compose([Validators.required, Validators.min(this.minimumReservePrice)])),
    });
    if(data){
      this.property=data.property;
      this.minimumReservePrice=(this.property.auction!.highestBidAmount?this.property.auction!.highestBidAmount:0)+(this.property.auction!.increment?this.property.auction!.increment:0);
    }
  }

  ngOnInit(){
    this.auctionUpdatedSubscription = this.property.auction!.auctionUpdatedSubject.subscribe(r =>{
      this.minimumReservePrice=(this.property.auction!.highestBidAmount?this.property.auction!.highestBidAmount:0)+(this.property.auction!.increment?this.property.auction!.increment:0);
      this.hotEditForm.get('reservePrice')!.setValidators(Validators.compose([Validators.required, Validators.min(this.minimumReservePrice)]));
      this.hotEditForm.updateValueAndValidity();
    });
  }

  ngOnDestroy(){
    if(this.auctionUpdatedSubscription)this.auctionUpdatedSubscription.unsubscribe();
  }

  onConfirmClick(): void {
    this.busy=true;
    this.propertyService.hotEditReservePrice(this.property.auction!.id, this.hotEditForm.get('reservePrice')!.value).pipe(take(1)).subscribe(r=>this.processHotEditResult(r));
  }
  onCancelClick(): void {
    this.dialogRef.close(false);
  }

  get canSubmit(){
    return this.hotEditForm.valid && !this.busy;
  }

  get canCancel(){
    return !this.busy;
  }

  private processHotEditResult(result:Result){
    this.busy=false;
    if(result.success){
      this.snackBar.open("Reserve successfully changed", '×', { panelClass: ['primary-snackbar'], verticalPosition: 'top', duration: 3000 });
    }
    else{
      this.snackBar.open("Reserve not changed: " + result.message, '×', { panelClass: ['warn-snackbar'], verticalPosition: 'top' });
    }
    this.dialogRef.close(false);
  }

}